module.exports = __webpack_public_path__ + "@/assets/img/css.6827470e.svg";